import React, { useState } from 'react';
import { storeRequestId } from '../api';

function TranslationForm({ onSubmit, loading }) {
  const [source, setSource] = useState('');
  const [category, setCategory] = useState('general');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!source.trim()) {
      return;
    }

    setSubmitting(true);
    try {
      const result = await onSubmit({
        source: source.trim(),
        sourceLanguage: 'en-US',
        targetLanguage: 'es-US',
        category,
      });
      
      // Store the request ID for tracking
      if (result.req_id) {
        storeRequestId(result.req_id);
      }
      
      // Clear form on success
      setSource('');
    } catch (error) {
      // Error handled by parent
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="card">
      <h2 className="card-title">Submit Translation Request</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label" htmlFor="source">
            English Text (Source)
          </label>
          <textarea
            id="source"
            className="form-textarea"
            value={source}
            onChange={(e) => setSource(e.target.value)}
            placeholder="Enter English text to translate..."
            required
            disabled={submitting || loading}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label" htmlFor="sourceLanguage">
              Source Language
            </label>
            <select
              id="sourceLanguage"
              className="form-select"
              value="en-US"
              disabled
            >
              <option value="en-US">English (en-US)</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="targetLanguage">
              Target Language
            </label>
            <select
              id="targetLanguage"
              className="form-select"
              value="es-US"
              disabled
            >
              <option value="es-US">Spanish (es-US)</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="category">
              Category
            </label>
            <select
              id="category"
              className="form-select"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              disabled={submitting || loading}
            >
              <option value="general">General</option>
              <option value="medical">Medical</option>
              <option value="legal">Legal</option>
              <option value="marketing">Marketing</option>
            </select>
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={submitting || loading || !source.trim()}
        >
          {submitting ? (
            <>
              <span className="spinner"></span>
              Submitting...
            </>
          ) : (
            'Submit Translation Request'
          )}
        </button>
      </form>
    </div>
  );
}

export default TranslationForm;
